import { render, staticRenderFns } from "./fidelior-profile.vue?vue&type=template&id=558637ba&"
import script from "./fidelior-profile.vue?vue&type=script&lang=js&"
export * from "./fidelior-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports